// Escalacao e sistema de jogo.
//
// O quinteto inicial e a minutagem sao GUARDADOS POR ID. Guardar por indice
// seria mais curto e quebraria na primeira venda: o indice 3 vira outro atleta.
//
// A minutagem e uma POLITICA, nao uma trava. Prender cinco atletas em quadra o
// jogo inteiro nao e escalacao, e congelamento -- e foi assim que um jogo
// anterior travou o time do usuario. Aqui o tecnico distribui a proporcao e o
// motor faz a rotacao seguindo ela.

import React, { useState } from 'react';
import { lineupInfo, setLineup, autoLineup, setTactics, userTeam } from '../engine/career.js';
import { TACTICS } from '../engine/tuning.js';
import { POSITION_LABEL } from '../engine/players.js';
import { Ovr } from './ui.jsx';

const GRUPOS = [
  ['pace', 'Ritmo'],
  ['offense', 'Ataque'],
  ['focus', 'Quem decide'],
  ['defense', 'Defesa'],
];

export function LineupScreen({ state, apply }) {
  const info = lineupInfo(state);
  const team = userTeam(state);
  const [starters, setStarters] = useState(info.starters);
  const [minutes, setMinutes] = useState(info.minutes);
  const [aba, setAba] = useState('escalacao');

  const roster = [...team.roster].sort((a, b) => (minutes[b.id] ?? 0) - (minutes[a.id] ?? 0));
  const somaMin = Object.values(minutes).reduce((a, b) => a + (Number(b) || 0), 0);

  const toggleStarter = (id) => {
    setStarters((cur) => {
      if (cur.includes(id)) return cur.filter((x) => x !== id);
      if (cur.length >= 5) return cur;
      return [...cur, id];
    });
  };

  const salvar = () => apply((s) => setLineup(s, { starters, minutes }));

  return (
    <>
      <div className="row wrap" style={{ gap: 6, marginBottom: 12 }}>
        {[['escalacao', 'Escalacao'], ['tatica', 'Sistema de jogo']].map(([id, label]) => (
          <button key={id} className={`sm ${aba === id ? 'primary' : 'ghost'}`} onClick={() => setAba(id)}>
            {label}
          </button>
        ))}
      </div>

      {aba === 'escalacao' && (
        <>
          <div className="card tight">
            <div className="row spread">
              <div>
                <h3 style={{ margin: 0 }}>Quinteto inicial</h3>
                <div className="small dim">
                  {starters.length}/5 escolhidos · rotacao{' '}
                  {info.auto ? 'automatica' : 'sua'}
                </div>
              </div>
              <button className="ghost sm" onClick={() => {
                apply((s) => autoLineup(s));
                const novo = lineupInfo(state);
                setStarters(novo.starters); setMinutes(novo.sugerido);
              }}>
                automatica
              </button>
            </div>
          </div>

          <div className="card">
            <div className="scroll">
              <table>
                <thead>
                  <tr>
                    <th className="n">atleta</th><th>ovr</th><th>titular</th><th>minutos</th>
                  </tr>
                </thead>
                <tbody>
                  {roster.map((p) => {
                    const titular = starters.includes(p.id);
                    return (
                      <tr key={p.id} className={titular ? 'me' : ''}>
                        <td className="n">
                          {p.name}
                          <span className="sub">{POSITION_LABEL[p.position]} · {p.age} anos</span>
                        </td>
                        <td><Ovr value={p.overall} /></td>
                        <td>
                          <button
                            className={`sm ${titular ? 'primary' : 'ghost'}`}
                            onClick={() => toggleStarter(p.id)}
                            disabled={!titular && starters.length >= 5}
                          >
                            {titular ? 'sim' : '—'}
                          </button>
                        </td>
                        <td>
                          <input
                            type="number" min="0" max="48" style={{ width: 62, padding: '5px 7px' }}
                            value={minutes[p.id] ?? 0}
                            onChange={(e) => setMinutes({ ...minutes, [p.id]: Number(e.target.value) })}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="row spread small dim" style={{ marginTop: 10 }}>
              <span>
                Somam {somaMin.toFixed(0)} minutos — o motor ajusta para os 240 do jogo.
              </span>
            </div>
          </div>

          <button
            className="primary" style={{ width: '100%', padding: 13 }}
            disabled={starters.length !== 5}
            onClick={salvar}
          >
            {starters.length === 5 ? 'Salvar escalacao' : `Escolha ${5 - starters.length} titular(es)`}
          </button>
          <div className="dim small" style={{ margin: '10px 0 26px' }}>
            Os minutos sao uma proporcao, nao uma trava: quem levar mais minutos
            joga mais, mas o motor continua fazendo a rotacao e tirando quem
            estiver com problema de faltas.
          </div>
        </>
      )}

      {aba === 'tatica' && (
        <>
          {GRUPOS.map(([grupo, titulo]) => (
            <div key={grupo} className="card">
              <h3>{titulo}</h3>
              <div className="grid" style={{ gap: 7 }}>
                {Object.entries(TACTICS[grupo]).map(([chave, opt]) => {
                  const ativo = info.tactics[grupo] === chave;
                  return (
                    <button
                      key={chave}
                      className={`club ${ativo ? 'on' : ''}`}
                      onClick={() => apply((s) => setTactics(s, { [grupo]: chave }))}
                    >
                      <div className="row spread">
                        <span className="nm">{opt.label}</span>
                        {ativo && <span className="tag">em uso</span>}
                      </div>
                      <div className="small dim">{opt.hint}</div>
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
          <div className="dim small" style={{ marginBottom: 26 }}>
            Toda escolha tem um custo. Bombardear de 3 sobe o placar e sofre
            menos falta, mas perde rebote de ataque; pressionar rouba mais bolas
            e comete mais faltas. Nenhuma opcao e so vantagem.
          </div>
        </>
      )}
    </>
  );
}
